module.exports = __webpack_public_path__ + "img/right.20c3e9f7.jpg";